import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { usePatientMutation } from '../../api/patient/usePatientMutation';
import { FormError } from '../form/FormError';
import { TextField } from "@mui/material";
export const PatientInlinePrimaryInsuranceForm = (props) => {
    const { onComplete, initialValue, patientId, initialEditing } = props;
    const [isEditing, setIsEditing] = useState(initialEditing);
    const { mutateAsync } = usePatientMutation();
    const { handleSubmit, register, formState: { errors }, } = useForm({
        defaultValues: {
            primaryInsurance: initialValue,
        },
    });
    const onSubmit = async (data) => {
        if (data.primaryInsurance !== initialValue) {
            if (data.primaryInsurance === '') {
                data.primaryInsurance = 'null';
                await mutateAsync({ patientId, ...data });
                data.primaryInsurance = '';
            }
            else {
                await mutateAsync({ patientId, ...data });
            }
            onComplete(data.primaryInsurance);
        }
    };
    return (React.createElement("form", { onSubmit: handleSubmit(onSubmit), noValidate: true, style: { borderRadius: '4px', border: isEditing ? '1px solid #2C78EB' : 'none', padding: isEditing ? '5px' : '0px' } },
        React.createElement("div", { className: "text-sm flex items-center", style: { height: '30px' } },
            React.createElement(TextField, { ...register('primaryInsurance'), id: "user-primary-insurance", variant: 'standard', style: { fontSize: 11, color: 'rgba(0, 0, 0, 0.87)', fontFamily: 'Barlow', fontWeight: '400', width: '100%', verticalAlign: 'middle' }, size: 'small', inputProps: { style: { height: '10px', fontSize: 12 } }, placeholder: 'N/A', onClick: () => setIsEditing(true), InputProps: {
                    disableUnderline: true,
                    readOnly: !isEditing, // disable editing when not in edit mode
                }, onBlur: (e) => {
                    const currentValue = e.target.value;
                    setIsEditing(false);
                    if (currentValue !== initialValue) {
                        handleSubmit(onSubmit)();
                    }
                    else {
                        props.onCancel();
                    }
                } })),
        React.createElement(FormError, { errors: errors, name: "primaryInsurance", className: "font-bold text-app-red-dark block text-sm mt-1" })));
};
